import type { FaireProductEntity } from "../../entity_types/product";

export const p_32rtdt5vhn: FaireProductEntity = {
  token: "p_32rtdt5vhn",
  type: "product",
  name: "ONE SHOULDER LACE MAXI DRESS",
  brandToken: "b_uxq2uydaxj",
  brandName: "One and Only Collective",
  imageUrl:
    "https://cdn.faire.com/fastly/232730cba85c01c2fef247230bfd15aaab5dc70e135d7a8648258a93c416b0e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b883e1924350c53f253841efbc0b064373cc0f7b1043bb84baf69921f0443270.jpeg",
  ],
  priceDollars: 35.5,
  description:
    "Command attention in the One-Shoulder Lace Maxi Dress, a timeless silhouette designed to flatter every curve. Crafted from luxurious stretch lace in a rich chocolate hue, this elegant gown features an asymmetrical off-the-shoulder neckline with softly ruched detailing, creating a sophisticated and feminine finish.\n\nDesigned with a figure-contouring fit, the dress skims the body before flowing into a graceful maxi-length hem for an effortlessly elegant look. The delicate lace texture adds depth and romance, making it the perfect choice for weddings, formal occasions, evening events, black-tie celebrations, and special occasions.\r\n90% POLYESTER / 10% ELASTANE",
  tags: [],
  msrpDollars: 92.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:45.024Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
